import { styled } from 'styled-components';

interface Props {
  onClose: () => void;
  title: string;
  description: string;
  buttonText: string;
  styles: any;
}

export const ConfirmDialog = ({
  onClose,
  title,
  description,
  buttonText,
  styles,
}: Props) => {
  return (
    <Wrapper style={styles}>
      <div className="header">{title}</div>
      <div className="content">{description}</div>
      <button onClick={onClose} className="footer__button">
        {buttonText}
      </button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 336px;
  height: 210px;
  display: flex;
  flex-direction: column;
  .header {
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
    color: black;
  }
  .content {
    display: flex;
    flex: 1;
    margin-top: 24px;
    font-size: 18px;
    line-height: 27px;
    color: #3d3d3d;
  }
  .footer__button {
    margin-top: auto;
    width: 100%;
    height: 48px;
    border-radius: 4px;
    background-color: #00bda5;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: white;
  }
`;
